module.exports = __webpack_public_path__ + "static/media/html5.f0361c5e.svg";